export default "__VITE_ASSET__DRZSy0z2__"